export default "__VITE_ASSET__t6$i0Uib__"